<template>
  <div>
    <fixed-header id="sticky-header">
      <div class="row form-header">
        <div class="col-sm-4 col-xl-4 m-auto" >
          <router-link 
            class="h6"
            tag="a"
            to="/administration/user"
            v-if="user.role.role == 'administration' || user.recruitment_type == 'company'"
          >
            <i class="uil-arrow-left"></i> {{$t('user.plural').toUpperCase()}}
          </router-link>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="mt-4 mt-md-0">
            <!-- <a href="#" class="btn btn-sm mx-1"><feather type="file-plus" class="icon-md"></feather></a>
            <a href="#" class="btn btn-sm mx-1"><feather type="mail" class="icon-md"></feather></a> -->
            <input 
              type='file' 
              id="attachmentUpload" 
              hidden=true
              @change="addAttachment" />
            <label for="attachmentUpload" class="btn btn2-tertiary btn-sm m-0 mx-1 text-muted"><feather type="file-plus" class="icon-md"></feather></label>

            <!-- <a 
              v-if="model.recruitment_type=='individual'"
              href="#" class="btn btn-sm mx-1"><feather type="calendar" class="icon-md"></feather>
            </a> -->

            <button 
              @click="onActivate"
              v-if="user.role.role == 'administration'"
              class="btn2 btn2-sm mr-1"
              :class="this.model.active ? 'btn2-primary' : 'btn2-primary'">{{
                !this.model.active ? $t('user.action.activate') : $t('user.action.deactivate')
              }}</button>

            <button 
              v-b-modal.change-pass-modal
              class="btn2 btn2-primary btn2-sm mr-1">{{$t('user.action.change_password')}}</button>
            <b-modal
								id="change-pass-modal"
								size="md"
								:title='$t("user.change_password_window.title")'
								title-class="font-18"
                no-close-on-esc
                no-close-on-backdrop
                centered
                :ok-title='$t("user.change_password_window.ok_button")'
                :cancel-title='$t("user.change_password_window.cancel_button")'
                @show="resetModal"
                @hidden="resetModal"
                @ok="onChangePassword"
								>
              <form ref="change-pass-form" @submit.stop.prevent="handleSubmit">
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='modalErrorMessage'>
                  {{modalErrorMessage}}
                </div>

                <TextField 
                  v-if="user.role.role != 'administration'"
                  :placeholder='$t("user.change_password_window.old_password.placeholder")'
                  :label='$t("user.change_password_window.old_password.label")'
                  icon="lock"
                  name="old_password"
                  type="password"
                  :value="change_pass.old_password"
                  v-model="change_pass.old_password"
                />

                <TextField 
                  :placeholder='$t("user.change_password_window.new_password.placeholder")'
                  :label='$t("user.change_password_window.new_password.label")'
                  icon="lock"
                  name="new_password"
                  type="password"
                  :value="change_pass.new_password"
                  v-model="change_pass.new_password"
                />

                <TextField 
                  :placeholder='$t("user.change_password_window.confirm_password.placeholder")'
                  :label='$t("user.change_password_window.confirm_password.placeholder")'
                  icon="lock"
                  name="confirm_password"
                  type="password"
                  :value="change_pass.confirm_password"
                  v-model="change_pass.confirm_password"
                />
              </form>
            </b-modal>

            <router-link
              tag="button"
              :to="'edit?id=' + $route.query.id"
              class="btn2 btn2-primary btn2-sm"
            >
              <i class="uil uil-edit mr-1"></i>{{$t('common.edit')}}
            </router-link>
          </div>
        </div>
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body pb-0">
            <div class="media">
              <img
                ref="imageAvatar"
                src="@assets/images/users/avatar-7.jpg"
                class="mr-3 avatar-xxl rounded-circle"
                alt=""
              />
              <div class="media-body">
                <h5 class="mt-3 mb-0">{{ model.recruitment_type == 'company' ? model.company_name : model.full_name }}</h5>
                <h6 class="font-weight-normal mt-1 mb-4 text-muted">
                  <p class="mb-1">{{ model.role.name | capitalize }}</p>
                </h6>
              </div>
              <span class="mt-1 mb-2 text-right ba  dge  badge-pill float-right"
                :class="model.active ? 'badge-success' : 'badge-danger'"
              >{{ model.active ? $t('job.badges.active') : $t('job.badges.deactivated') }}</span>
            </div>
            <div class="mt-3" v-if="user.role.role === 'administration'">
              <h6 class="mt-1 mb-0 font-size-15">{{$t('company.form.fees')}}</h6>

              <h6 class="text-muted font-weight-normal mt-1 mb-3">
                {{model.fixed && model.rate ? model.rate.$numberDecimal : '' | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2)}}
                {{!model.fixed && model.rate ? model.rate.$numberDecimal + '%' : '0'}}
              </h6>
            </div>

            <div class="mt-3" v-if="model.company_details">
              <h4 class="mb-3 font-size-15">{{$t('user.form.summary')}}</h4>
              <div v-html="model.company_details"></div>
            </div>

            <div class="mt-3">
              <div class="mt-4 pt-3 border-top text-left">

                <ul class="list-unstyled events mb-0 font-1 text-muted">
                  <li class="my-2" v-if="model.country"><i class="mr-2 uil-location-point"></i> {{model.city}} {{model.country}}</li>
                  <li class="my-2" v-if="model.contact_no"><i class="mr-2 uil-phone"></i> {{ model.contact_no }}</li>
                  <li class="my-2" v-if="model.email"><i class="mr-2 uil-envelope"></i> {{model.email}}</li>
                  <li class="my-2" v-if="model.skype"><i class="mr-2 uil-skype"></i> {{model.skype}}</li>
                  <li class="my-2" v-if="model.website"><i class="mr-2 uil-globe"></i> {{model.website}}</li>
                </ul>

                <div class="social-feeds">
                  <a href="" v-if="model.facebook"><i class="uil-facebook"></i></a>
                  <a href="" v-if="model.twitter"><i class="uil-twitter text-info"></i></a>
                  <a href="" v-if="model.dribble"><i class="uil-dribbble text-danger"></i></a>
                  <a href="" v-if="model.behance"><i class="uil-behance"></i></a>
                </div>
              </div>
              <hr>
              <div class="media-body p-1" >
                <h6 class="mt-1 mb-0 font-size-15">{{$t('user.form.industry.label')}}</h6>
                <div class="mt-1 mb-3">
                  <span v-if="!model.industry_id.length">N/A</span>
                  <span class="badge badge-pill badge-soft-primary mr-2 mb-2" 
                    v-for="item in model.industry_id"
                    :key="item._id">
                    {{item.name}}
                  </span>

                  <!-- <span v-if="model.industry_id.length == 0">
                    N/A
                  </span> -->
                </div>
              </div>
              <div class="media-body p-1">
                <h6 class="mt-1 mb-0 font-size-15">{{$t('user.form.function.label')}}</h6>
                <div class="mt-1 mb-3">
                  <span v-if="!model.function_id.length">N/A</span>
                  <span class="badge badge-pill badge-soft-primary mr-2 mb-2" 
                    v-for="item in model.function_id"
                    :key="item._id">
                    {{item.name}}
                  </span>

                  <!-- <span v-if="model.function_id.length == 0">
                    N/A
                  </span> -->
                </div>
              </div>

              <div class="media-body p-1">
                <h6 class="mt-1 mb-0 font-size-15">{{$t('user.form.brand.label')}}</h6>
                <div class="mt-1 mb-3">
                  <span v-if="!model.brand_id">N/A</span>
                  <span class="badge badge-pill badge-soft-primary mr-2 mb-2" 
                    v-for="item in model.brand_id"
                    :key="item._id">
                    {{item.name}}
                  </span>

                  <!-- <span v-if="model.function_id.length == 0">
                    N/A
                  </span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg 4" v-if="model.recruitment_type == 'company'">
        <div class="card">
          <div class="card-body">
            <div class="row" >
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Contact Person</label>
                    <div>{{model.contact_person}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Contract Start Date</label>
                    <div>{{dateFormatted(model.contract_start_date)}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Contract End Date</label>
                  <div>{{dateFormatted(model.contract_end_date)}}</div>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="card">
          <div class="card-body">
            <h5 class="card-title pb-2 border-bottom">User(s) 
              <router-link
                tag="button"
                :to="'/administration/user/create?id='+this.model._id"
                class="btn2 btn2-primary btn-sm mr-1 mb-3 mb-sm-0"
              >
                <i class="uil-plus mr-1"></i> Add User
              </router-link>
            </h5>
            <TableUser 
              :header="false"
              :noPerPage="false"
              :param="{
                user_id:this.model._id,
                access_type:'staff'
              }"
              :useAs="'user'"  
            />
          </div>
        </div> -->
        <div class="card">
          <div class="card-body">
            <h5 class="card-title pb-2 border-bottom">Recruiter(s) 
              <router-link
                tag="button"
                :to="'/administration/user/create?type=individual&id='+this.model._id"
                class="btn2 btn2-primary btn-sm mr-1 mb-3 mb-sm-0"
              >
                <i class="uil-plus mr-1"></i> Add Recruiter
              </router-link>
            </h5>
            <TableUser
              :header="false"
              :noPerPage="false"
              :param="{
                user_id:this.model._id,
                recruitment_type:'individual'
              }"
              :useAs="'recruiter'"
            />
          </div>
        </div>
      </div>

      <div :class="this.model.recruitment_type != 'company' ? 'col-lg-8' : 'col-lg-4'">
        <div class="card">
          <div class="card-body">
            <b-tabs pills justified class="col-12 application-view-height bg-white navtab-bg p-2">
              <b-tab class="pt-3" :title="$t('user.form.suitable_jobs')" active>
                <div 
                  class="text-center"
                >{{$t('user.form.empty_suitable_jobs')}}</div>
              </b-tab>
              <b-tab class="pt-3" :title="$t('user.form.applications')">
                <!-- <div 
                  class="text-center"
                >{{$t('user.form.empty_applications')}}</div> -->
                <ApplicationTable
                  ref="applicationTable"
                  :initialLoad="true"
                  initialType="application"
                />
              </b-tab>
              <b-tab class="pt-3" :title="$t('user.form.interviews')">
                <div 
                  class="text-center"
                >{{$t('user.form.empty_interviews')}}</div>
              </b-tab>
              <b-tab class="pt-3" :title="$t('user.form.activities')">
                <VuePerfectScrollbar style="max-height: 500px">
                  <div 
                    class="text-center"
                    v-if="!model.activities.length"
                  >{{$t('user.form.empty_activities')}}</div>

                  <div class="custom-timeline pl-4" 
                    v-for="item in model.activities"
                    :key="item._id"
                  >
                    <ul class="list-unstyled events">
                      <li class="event-list" >
                        <div v-if="item.type != 'application'">
                          <div class="event-date text-muted pt-2">
                            <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                          </div>
                          <div class="media">
                            <div class="media-body">
                              
                              <div class="card">
                                <div class="card-body mt-3">
                                  <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                  <p class="text-muted">
                                    {{ item.description }}
                                  </p>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div v-if="item.type == 'application'">
                          <div class="event-date text-muted pt-2">
                            <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                          </div>
                          <div class="media">
                            <div class="media-body">
                              
                              <div class="card">
                                <div class="card-body mt-3">
                                  <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                  <p class="text-muted">
                                    {{ item.description }}
                                  </p>
                                  <div>Position: {{ item.job_id.title }}</div>
                                  <div>Company: {{ item.job_id.company_id.name }}</div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                </VuePerfectScrollbar>
              </b-tab>
              <b-tab class="pt-3" :title="$t('user.form.files')">
                <div class="text-center"
                  v-if="!attachmentDatas.length && !attachmentPDFDatas.length"
                >{{$t('user.form.empty_files')}}</div>
                <div v-else class="row">
                  <div class="text-left col-lg-12">
                    <div class="card">
                      <div class="card-body">
                        <div 
                          v-for="(item, idx) in attachmentDatas"
                          :key="item._id"
                        >
                          <div class="section">
                            <div class="'collapsible">
                              <div class="p-1 px-2">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <img 
                                      src="@assets/images/projects/project-1.jpg"
                                      class="avatar-sm rounded"
                                      alt="file-image"
                                    >
                                  </div>
                                  <div class="col pl-0" style="white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;">
                                      <a href="javascript:void(0);" class="text-muted font-weight-bold">
                                        {{ item.fileName }}
                                      </a>
                                      <p class="mb-0">{{ item.size.$numberDecimal | bytes }}</p>
                                  </div>
                                  <div class="col-auto">
                                    <a
                                      @click="onDownloadAttachment(item._id, idx)"
                                      data-toggle="tooltip" 
                                      data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                      data-original-title="Download">
                                        <i class="uil uil-cloud-download font-size-14"></i>
                                    </a>
                                    <a
                                      @click="onDeleteAttachment(item._id, idx)"
                                      data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                        <i class="uil uil-multiply font-size-14"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div 
                          v-for="(item, idx) in attachmentPDFDatas"
                          :key="item._id"
                        >
                          <div class="section">
                            <div :class="[item.isActive ? 'active' : '', 'collapsible']" @click="item.isActive = !item.isActive">
                              <div class="p-1 px-2">
                                <div class="row align-items-center">
                                  <span class="toggleIcon" id="toggleIcon">{{ !item.isActive ? '+' : '-' }}</span>
                                  <div class="col-auto">
                                      <img src="@assets/images/projects/project-1.jpg" class="avatar-sm rounded" alt="file-image">
                                  </div>
                                  <div class="col pl-0" style="white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;">
                                      <a href="javascript:void(0);" class="text-muted font-weight-bold">{{ item.fileName }}</a>
                                      <p class="mb-0">{{ item.size.$numberDecimal | bytes}}</p>
                                  </div>
                                  <div class="col-auto">
                                    <a
                                      @click="onDownloadAttachment(item._id, idx)"
                                      data-toggle="tooltip" 
                                      data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                      data-original-title="Download">
                                        <i class="uil uil-cloud-download font-size-14"></i>
                                    </a>
                                    <a
                                      @click="onDeleteAttachment(item._id, idx, true)"
                                      data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                        <i class="uil uil-multiply font-size-14"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <pdf
                            v-for="i in item.numPages"
                            :key="i"
                            :src="item.src"
                            :page="i"
                            style="display: inline-block; width: 100%"
                            v-show="item.isActive"
                          />
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <file-downloader :key="downloadKey" ref="downloader"></file-downloader>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import FixedHeader from 'vue-fixed-header'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FileDownloader from '@components/fileDownloader'
import TextField from '@components/form/textfield.vue'
import TableUser from './table/user'
import moment from 'moment/moment'
import pdf from 'vue-pdf'
import ApplicationTable from '@pages/application/table.vue'

export default {
  mixins: [FormMixin],
  components:{FixedHeader, VuePerfectScrollbar, FileDownloader, TextField, TableUser, pdf, ApplicationTable},
  data(){
    return {
      model:{
        full_name: '',
        email: '',
        contact_no: '',
        work_experiences:[],
        education_background:[],
        skills:[],
        tags:[],
        attachments:[],
        function_id:[],
        industry_id:[],
        activities:[],
        role: {}
      },
      attachmentDatas: [],
      attachmentPDFDatas: [],
      users:[],
      recruiters:[],
      change_pass:{
        old_password:'',
        new_password:'',
        confirm_password:'',
      },
      downloadKey: 1,
      modalErrorMessage:'',
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  computed: {
    present_work: function() {
      let position
      for(var key in this.model.work_experiences){
        var work = this.model.work_experiences[key]
        if(work.present == true){
          position = work.position
        }
      }
      return position
    },
    currency_symbol(){
      var symbol = ""
      if(this.model.currency_id){
        symbol = this.model.currency_id.symbol
      }
      return symbol
    }
  },
  updated() {
    this.handleResize()
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
    // this.$refs['applicationTable'].fetchData('application')
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('user', ['findUser', 'uploadAttachment', 'downloadAttachment', 'deleteAttachment', 'changePassword', 'activate']),
    dateFormatted(val){
      return moment(val).format('YYYY-MM-DD')
    },
    addAttachment(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("file", input.files[0]);
        formData.append("id", this.$route.query.id);

        this.uploadAttachment(formData).then(res => {

          if(res.data.success == true){
            this.parseDocuments(res.data.attachment)
            /* var reader = new FileReader();

            reader.onload = (a) => {
              this.$refs['imagePreview'].src = a.target.result
              NProgress.done()
            }

            reader.readAsDataURL(input.files[0]); */
            this.toggleLoading()
          }else{
            this.toggleLoading()
          }
          
        })
      }
    },
    onDownloadAttachment(uiid){
      /* this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data){  
            this.$nextTick().then(() => {
              this.$refs.downloader.downloadFile(res.config.baseURL.replace('api', '') +  res.data.path)
            })
          }
        }
        
      }) */
      this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data.attachment){  
            const url = res.data.baseUrl + '/' +  res.data.attachment.path
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', res.data.attachment.originalname) //or any other extension
            link.setAttribute('target', '_blank') //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
            /* this.$nextTick().then(() => {
              this.$refs.downloader.downloadFile(res.config.baseURL.replace('api', '') +  res.data.path)
            }) */
          }
        }
        
      })
    },
    onDeleteAttachment(uiid, idx, isPDF = false){
      this.deleteAttachment({
        id:uiid
      }).then(res => {
        if(res.data.success){
          alert('Attachment was successfully deleted!')
        }
        if(isPDF) {
          this.attachmentPDFDatas.splice(idx, 1)
        } else {
          this.attachmentDatas.splice(idx, 1)

        }
      })
    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}

      this.create(this.model)
      .then(()=> {
        this.toggleLoading()
         this.$router.push('/administration/user')
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    async fetchData(){
      await this.findUser({
        id:this.$route.query.id
      }).then(data => {
        this.model = data.data
        this.parseDocuments()
      })
      if(this.model.avatar_path && this.$refs['imageAvatar']){
        this.$refs['imageAvatar'].src = this.model.avatar_path
      }
    },
    async fetchUser(){
      /* await this.findUser({
        id:this.$route.query.id
      }).then(data => {
        this.model = data.data
        if(this.model.avatar_path){
          this.$refs['imageAvatar'].src = this.model.avatar_path
        }
      }) */
    },
    async fetchRecruiter(){
      /* await this.findUser({
        id:this.$route.query.id
      }).then(data => {
        this.model = data.data
        if(this.model.avatar_path){
          this.$refs['imageAvatar'].src = this.model.avatar_path
        }
      }) */
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/administration/user')
    },
    onChangePassword(event) {
      event.preventDefault()

      this.change_pass.id = this.$route.query.id
      this.modalErrorMessage = ''

      this.changePassword(this.change_pass).then(res => {
        if(res.data.success){
          // Trigger submit handler
          this.$nextTick(() => {
            this.$bvModal.hide('change-pass-modal')
          })

          /* this.$bvModal.msgBoxOk('Password is now changed!',{
            title: 'Notification'
          }) */

          this.$bvToast.toast(`Password is now changed!`, {
            title: 'Notification',
            variant:'success'
          })

        }else{
          this.modalErrorMessage = res.data.errorMessage
        }

      })
    },
    resetModal(){
      this.change_pass.old_password = ''  
      this.change_pass.new_password = ''
      this.change_pass.confirm_password = ''
    },
    onActivate () {
      console.log(this.$refs)
      this.$bvModal.msgBoxConfirm('Are you sure you want to ' + (this.model.active ? 'Deactivate' : 'Activate'), {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()

          this.activate(this.model).then(res => {
            this.model.active = res.data.active
            this.$bvToast.toast(`User ${this.model.full_name} has been ${res.data.active ? 'Activated' : 'Deactivated'}!`, {
              title: 'Notification',
              variant:'success'
            })
            this.toggleLoading()
          })
        }
      })
    },
    parseDocuments(attachment){
      let attachmentData = this.model.attachments

      if(attachment) {
        attachmentData = []
        attachmentData.push(attachment)
      }
      if(attachmentData.length > 0){
        for(let index = 0; index < attachmentData.length; index++) {
          const element = attachmentData[index];
          if(element.mimetype == 'application/pdf'){
            let pdfsrc = pdf.createLoadingTask(`${process.env.VUE_APP_SERVER_URL}/${element.path}`)
            let numPages = undefined
            pdfsrc.promise.then(pdf => {
              numPages = pdf._pdfInfo.numPages;
              let result = {
                src: pdfsrc,
                numPages,
                currentPage: 0,
                fileName: element.originalname,
                size: element.size,
                _id: element._id,
                isActive: attachmentData.length > 1 ? false : true
              }
              this.attachmentPDFDatas.push(result)
            })
          }else{
            let result = {
              fileName: element.originalname,
              size: element.size,
              _id: element._id,
              isActive: false
            }
            this.attachmentDatas.push(result)
          }
        }
      }
    },
  },
  
  /* watch: {
    'change_pass.old_password':{
      handler: function() {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.fetchResults({ query: this.search });
            this.awaitingSearch = false;
          }, 500); // 1 sec delay
        }
        this.awaitingSearch = true;
      }
    }
  } */
}
</script>

<style>
  .ps__rail-y{
    z-index:1
  }
  .ps__rail-x{
    z-index:1
  }
</style>